import { render, staticRenderFns } from "./PressInspectionSearch.vue?vue&type=template&id=24162369&"
import script from "./PressInspectionSearch.vue?vue&type=script&lang=js&"
export * from "./PressInspectionSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports